import type { ReactNode } from "react";
import { SUBSCRIPTION_RECORDS_EXPIRED_MESSAGE, SUBSCRIPTION_REQUIRED_MESSAGE } from "../subscriptions/access";
import { Notice } from "./Feedback";
import { NavLink } from "./NavLink";

export function RequestNotice({ title, message, children }: { title: string; message: string; children?: ReactNode }) {
  if (message === SUBSCRIPTION_REQUIRED_MESSAGE || message === SUBSCRIPTION_RECORDS_EXPIRED_MESSAGE) {
    return <Notice title={message === SUBSCRIPTION_RECORDS_EXPIRED_MESSAGE ? "Record access ended" : "Subscription required"} tone="danger"><p>{message}</p><NavLink active={false} href="/settings/billing">View billing</NavLink></Notice>;
  }
  return <Notice title={title} tone="danger">{message}{children}</Notice>;
}
